import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { v4 as uuid } from 'uuid';
import { CreateCustomer, CustomerResponse, Customers, AddressMappingRequest, AddressMappingResponse } from '../model/customer';
import { LookUpKeyValueforDomainList, LookupMenuUpdateArr } from '../model/lov';
import { VendorSummay } from '../model/vendor';

@Injectable({
   providedIn: 'root'
})
export class CustomerService {

   allCustomerList: Customers[] = [];
   
   constructor(
      private http: HttpClient
   ) { }

   saveCustomer(customers: CreateCustomer): Observable<CustomerResponse> {
      const headers = new HttpHeaders({
         'Content-Type': 'application/json',
         APPID: environment.apiBussServAPPID,
         UUID: uuid()
      });
      const options = { headers };
      return this.http.post<CustomerResponse>(environment.apiCustomerURL, JSON.stringify(customers), options);
   }


   updateCustomer(customers: CreateCustomer): Observable<CustomerResponse> {
      const headers = new HttpHeaders({
         'Content-Type': 'application/json',
         APPID: environment.apiBussServAPPID,
         UUID: uuid()
      });
      const options = { headers };
      return this.http.patch<CustomerResponse>(environment.apiCustomerURL, JSON.stringify(customers), options);
   }

   getCustomerKeyValue(domainList: string[]): Observable<LookUpKeyValueforDomainList> {
      const httpOptions = {
         headers: {
            'Content-Type': 'application/json',
            APPID: environment.apiBussServAPPID,
            UUID: uuid()
         },
         params: { active: 'Y', lookupNames: domainList }
      };
      return this.http.get<LookUpKeyValueforDomainList>(environment.apiLookupURL, httpOptions);
   }

   getCustomerSummary(pageNumber: string, pageLimit: string, customers: Customers, responseFilter: string): Observable<CustomerResponse> {

      let params = new HttpParams();
      params = params.append('page', pageNumber);
      params = params.append('pageLimit', pageLimit);
      if (customers.customerName) {
         params = params.append('customerName', customers.customerName);
      }

      if (customers.customerId) {
         params = params.append('customerId', '' + customers.customerId);
      }

      if (customers.customerCode) {
         params = params.append('customerCode', customers.customerCode);
      }
      params = params.append('responseFilter', responseFilter);

      const httpOptions = {
         headers: {
            'Content-Type': 'application/json',
            APPID: environment.apiBussServAPPID,
            UUID: uuid()
         },
         params
      };

      return this.http.get<CustomerResponse>(environment.apiCustomerURL, httpOptions);
   }


   getCustomerDetails(custId: string, responseFilter: string): Observable<CustomerResponse> {
      // TODO: Remove mock response before production
      // const mockResponse: CustomerResponse = {
      //    requestIdentifier: '410136cf-4511-446b-a0e4-4bd69dc87620',
      //    transactionDate: '2026-05-06 12:42:06.16',
      //    success: true,
      //    customers: [
      //       {
      //          customerCode: 'EL',
      //          customerId: 1055,
      //          customerName: 'Estee Lauder',
      //          active: true,
      //          creationDate: '2024-07-01T10:25:36.799Z',
      //          enrollmentType: 'FL',
      //          businessUnits: [
      //             {
      //                buId: 955,
      //                businessUnitCode: 'EL',
      //                businessUnitName: 'Estee Lauder',
      //                active: true,
      //                addressInformation: {
      //                   addressLine1: '50 N Twelfth St',
      //                   addressLine3: 'MSTest',
      //                   city: 'Leymone',
      //                   state: 'PA',
      //                   postalCode: '17043',
      //                   country: 'US',
      //                   additionalAddress: [
      //                      {
      //                         buAdditionalAddrId: 1,
      //                         addressCode: 'Return Warehouse address',
      //                         customerEIN: 'CUS9089007',
      //                         addressLine1: '6155 El Camino Real',
      //                         addressLine2: null,
      //                         addressLine3: null,
      //                         city: 'Carlsbad',
      //                         state: 'CA',
      //                         country: 'US',
      //                         postalCode: '92009',
      //                         contacts: [
      //                            {
      //                               contactName: 'Sudheer',
      //                               email: 'christopher.baker2@fedex.com',
      //                               phone: '9999999999',
      //                               primaryContact: true
      //                            }
      //                         ]
      //                      }
      //                   ]
      //                },
      //                createdBy: 'Portal',
      //                contacts: [
      //                   {
      //                      contactName: 'Srinivasa',
      //                      phone: '9175675678',
      //                      email: 'test@test.com',
      //                      active: false,
      //                      creationDate: '2026-05-06T09:37:51.096Z',
      //                      contactId: 6926,
      //                      primaryContact: true
      //                   }
      //                ],
      //                facilities: [
      //                   {
      //                      facilityName: 'Lemoyne',
      //                      creationDate: '2026-04-07T06:53:48.360Z',
      //                      facilityID: 862,
      //                      associationId: 3136,
      //                      instanceId: '02',
      //                      serviceType: 'R',
      //                      active: true,
      //                      timeZone: 'America/Chicago',
      //                      gmtOffsetHours: '-5.0',
      //                      instanceName: 'FSC_02'
      //                   }
      //                ],
      //                creationDate: '2021-07-22T16:25:36.799Z'
      //             }
      //          ]
      //       }
      //    ],
      //    paging: {
      //       last: true,
      //       first: true,
      //       totalPages: 1,
      //       totalElements: 1,
      //       size: 25,
      //       number: 0,
      //       numberOfElements: 1
      //    }
      // } as any;
      // return of(mockResponse);

      let params = new HttpParams();
      params = params.append('customerId', '' + custId);
      params = params.append('responseFilter', responseFilter);


      const httpOptions = {
         headers: {
            'Content-Type': 'application/json',
            APPID: environment.apiBussServAPPID,
            UUID: uuid()
         },
         params
      };

      return this.http.get<CustomerResponse>(environment.apiCustomerURL, httpOptions);
   }

   getCustomerDetailsviaBUName(businessUnitName: string, responseFilter: string): Observable<CustomerResponse> {

      let params = new HttpParams();
      params = params.append('businessUnitName', '' + businessUnitName);
      params = params.append('equalOperation', 'true');
      params = params.append('responseFilter', responseFilter);

      const httpOptions = {
         headers: {
            'Content-Type': 'application/json',
            APPID: environment.apiBussServAPPID,
            UUID: uuid()
         },
         params
      };

      return this.http.get<CustomerResponse>(environment.apiCustomerURL, httpOptions);
   }

   getCustomerIdsInSummary(pageNumber: string, pageLimit: string, customerIds: string,
      responseFilter: string): Observable<CustomerResponse> {

      let params = new HttpParams();
      params = params.append('page', pageNumber);
      params = params.append('pageLimit', pageLimit);
      params = params.append('customerId', customerIds);
      params = params.append('responseFilter', responseFilter);
      
      const httpOptions = {
         headers: {
            'Content-Type': 'application/json',
            APPID: environment.apiBussServAPPID,
            UUID: uuid()
         },
         params
      };

      return this.http.get<CustomerResponse>(environment.apiCustomerURL, httpOptions);
   }


   validateUniqueCustomerCode(customer) {
      const httpOptions = {
         headers: {
            'Content-Type': 'application/json',
            APPID: environment.apiBussServAPPID,
            UUID: uuid()
         },
         params: {
            customerCode: customer, responseFilter: 'summary'
         }
      };
      return this.http.get<CustomerResponse>(environment.apiCustomerURL, httpOptions);
   }

   
   getDocumentAddressMappings(custId: string, buId?: string, active?: string): Observable<AddressMappingResponse> {
      // TODO: Remove mock response before production
      // const mockResponse: DocumentAddressMappingResponse = {
      //    success: true,
      //    requestIdentifier: '0001',
      //    transactionDate: '2026-05-04T11:11:00Z',
      //    documentAddressMappings: [
      //       {
      //          configGroupId: 1,
      //          custId: 1055,
      //          buId: 955,
      //          orderAttributeName: 'ORDER_TYPE',
      //          orderAttributeVals: ['B2C', 'B2B'],
      //          documentTypes: ['ComInvStd'],
      //          addressRoles: ['SHIP_FROM'],
      //          addressCode: 'Return Warehouse address',
      //          active: 'Y',
      //          deleted: 'N'
      //       }
      //    ]
      // } as any;
      // return of(mockResponse);

      let params = new HttpParams();
      params = params.append('custId', custId);
      if (buId) { params = params.append('buId', buId); }
      if (active) { params = params.append('active', active); }

      let headers = new HttpHeaders({
         'Content-Type': 'application/json',
         APPID: environment.apiBussServAPPID,
         UUID: uuid(),
         FSC_USER: localStorage.getItem('USERID') || '',
         custId: custId
      });

      return this.http.get<AddressMappingResponse>(`${environment.apiCustomerURL}/bu-address-mapping`, { headers, params });
   }

   createDocumentAddressMappings(payload: AddressMappingRequest): Observable<AddressMappingResponse> {
      const headers = new HttpHeaders({
         'Content-Type': 'application/json',
         APPID: environment.apiBussServAPPID,
         UUID: uuid()
      });
      return this.http.post<AddressMappingResponse>(`${environment.apiCustomerURL}/bu-address-mapping`, JSON.stringify(payload), { headers });
   }

   updateDocumentAddressMappings(payload: AddressMappingRequest): Observable<AddressMappingResponse> {
      const headers = new HttpHeaders({
         'Content-Type': 'application/json',
         APPID: environment.apiBussServAPPID,
         UUID: uuid()
      });
      return this.http.patch<AddressMappingResponse>(`${environment.apiCustomerURL}/bu-address-mapping`, JSON.stringify(payload), { headers });
   }

   getEmailTemplate(facilityId:string,custId:string,businessId:string,templateName:string) {
      const httpOptions = {
         headers: {
            'Content-Type': 'application/json',
            APPID: environment.apiBussServAPPID,
            UUID: uuid()
         },
         params: {
            fcyId: facilityId,
            custId:custId,
            buId: businessId,
            templateName:templateName
         }
      };
      return this.http.get<any>(environment.apiPackServiceURL+ '/getEmailTemplateDetails', httpOptions);
   }
   updateEmailLookupValues(LookupRequest: LookupMenuUpdateArr): Observable<LookUpKeyValueforDomainList> {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
        FSC_USER: localStorage.getItem('USERID'),
      });

      const options = { headers };
      return this.http.post<LookUpKeyValueforDomainList>(environment.apiLookupURL + '/lookupvalues', JSON.stringify(LookupRequest), options);
    }
   //  getVendorList(customerId:string,):Observable<any>{
   //    const httpOptions = {
   //       headers: {
   //          'Content-Type': 'application/json',
   //          APPID: environment.apiBussServAPPID,
   //          UUID: uuid(),
   //          FSC_USER: localStorage.getItem('USERID'),
   //          "CUST_ID": customerId,
   //       },
   //       params: {
   //          "customerId":customerId
   //       }
   //    }
   //    return this.http.get<any[]>(environment.apiVendorURL, httpOptions);
   // }
   getVendorList(custId: number, searchType: string): Observable<VendorSummay> {
      const httpOptions = {
        headers: {
          'Content-Type': 'application/json',
          APPID: environment.apiBussServAPPID,
          UUID: uuid(),
          responseFilter: 'detail',
        },
        params: {
          customerId: (custId).toString(),
          vendorName:searchType
        },
      };
  
      return this.http.get<VendorSummay>(environment.apiVendorURL, httpOptions);
    }

    updateToggleLookupValues(LookupRequest: LookupMenuUpdateArr): Observable<LookUpKeyValueforDomainList> {
      console.log('LookupMenuUpdateArr request=> ', JSON.stringify(LookupMenuUpdateArr));
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
        FSC_USER: localStorage.getItem('USERID'),
      });
  
      const options = { headers };
      return this.http.put<LookUpKeyValueforDomainList>(environment.apiLookupURL + '/lookupvalues', JSON.stringify(LookupRequest), options);
    }
    
}
